import { fromEvent } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { sendMessageToWebApp } from "./webAppMessenger";
import { NEW_VISUAL_VEWPORT } from "./messageTypes";

if (window.visualViewport) {
  const visualViewportResize = fromEvent(window.visualViewport, "resize");
  visualViewportResize.pipe(debounceTime(200)).subscribe(() => {
    const { width, height } = window.visualViewport;
    window.scrollTo(0, 0);
    sendMessageToWebApp(NEW_VISUAL_VEWPORT, { visualViewport: { width, height } });
  });
}
